import { createClient } from '@supabase/supabase-js';
import { Database } from '@/integrations/supabase/types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

/**
 * Custom Supabase client configured for browser-session-only authentication.
 * 
 * Using sessionStorage instead of localStorage ensures that:
 * - Sessions persist during page refreshes and navigation within the same browser session
 * - Sessions are automatically cleared when the browser is completely closed
 * - Each browser window/tab maintains its own independent session
 * 
 * This provides enhanced security by preventing sessions from persisting indefinitely
 * while maintaining a smooth user experience during active browsing.
 */
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: sessionStorage,     // Use sessionStorage instead of localStorage
    persistSession: true,         // Persist during browser session
    autoRefreshToken: true,       // Keep auto-refresh for active sessions
    detectSessionInUrl: true,     // Detect session from URL fragments
  }
});
